package com.evoapps.evoshift.data.dto.roster

import com.evoapps.evoshift.data.dto.system.MetadataDto
import kotlinx.serialization.Serializable

/** SH-223: `work_requests/{id}`: remote work, a work event or overtime (never read by older apps). */
@Serializable
data class WorkRequestDto(
    val id: String = "",
    val userId: String,
    val workplaceId: String,
    /** WorkRequestKind name. */
    val kind: String,
    /** PENDING, APPROVED or REJECTED. */
    val status: String,
    val startDate: String,
    val endDate: String,
    val startTime: String? = null,
    val endTime: String? = null,
    val placeId: String? = null,
    val placeName: String? = null,
    val note: String? = null,
    val rejectionReason: String? = null,
    val processedBy: String? = null,
    val processedAt: String? = null,
    val metadata: MetadataDto
)

/** SH-223: `workplaces/{id}/work_places/{placeId}`. */
@Serializable
data class RequestPlaceDto(
    val name: String,
    val createdBy: String = "",
    val createdAt: String = ""
)
